module.exports = "//public.zight.com/packs/media/images/star_default-a70772ee8413b05c8955a593a45f1176.svg";